// app/javascript/controllers/mobile_menu_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  toggle() {
    this.overlayTarget.classList.toggle('hidden')
  }

  close() {
    this.overlayTarget.classList.add('hidden')
  }
}
